import { useCallback, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'reduxTyped'

import * as userFieldsActions from 'common/fields/actions/userFieldsActions'
import * as filterFieldsActions from 'common/filter/actions/filterFields'
import { FilterFieldsState } from 'common/filter/reducers/interfaces'
import { getFilterFields } from 'common/filter/selectors/filterFields'

export type UseFilterFieldsOptions = filterFieldsActions.FetchFilterFieldsPayload

interface UseFilterFieldsReturnType extends FilterFieldsState {
  create: (title: string) => void
}

export function useFilterFields(options: UseFilterFieldsOptions = {}): UseFilterFieldsReturnType {
  const dispatch = useAppDispatch()
  const state = useAppSelector(getFilterFields)

  const create = useCallback(
    (title: string) => {
      dispatch(
        userFieldsActions.openCreateFieldModal({
          title,
        }),
      )
    },
    [dispatch],
  )

  const { scenario, allowUserId, force = false } = options
  useEffect(() => {
    dispatch(filterFieldsActions.fetchFilterFields({ scenario, allowUserId, force }))
    dispatch(userFieldsActions.fetchUserFields())
  }, [dispatch, scenario, allowUserId, force])

  return {
    ...state,
    create,
  }
}
